import React, { Component } from "react";
import PropTypes from "prop-types";
import axiosClient from "./constants";
import { Dropdown } from 'primereact/dropdown';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { AutoComplete } from 'primereact/autocomplete';
import smartNavigation from './SmartNavigation.json';

export class AppTopbar extends Component {
  static defaultProps = {
    onMenuButtonClick: null,
    onTopbarMenuButtonClick: null,
    onTopbarItemClick: null,
    profileMode: null,
    horizontal: false,
    topbarMenuActive: false,
    activeTopbarItem: null,
  };

  static propTypes = {
    onMenuButtonClick: PropTypes.func.isRequired,
    onTopbarMenuButtonClick: PropTypes.func.isRequired,
    onTopbarItemClick: PropTypes.func.isRequired,
    profileMode: PropTypes.string.isRequired,
    horizontal: PropTypes.bool.isRequired,
    topbarMenuActive: PropTypes.bool.isRequired,
    activeTopbarItem: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.snapshot = this.snapshot.bind(this);
    this.searchNavs = this.searchNavs.bind(this);
    this.submitSnapshot = this.submitSnapshot.bind(this);
    this.deleteBodyTemplate = this.deleteBodyTemplate.bind(this);
    this.restoreBodyTemplate = this.restoreBodyTemplate.bind(this);

    this.state = {
      currentEntity: "",
      entities: [],
      showEntityDialog: false,
      redirect: false,
      showEntityButton: true,
      showSnapshotDialog: false,
      snapshotsResponse: {
        snapshots: [],
        quotaReached: false
      },
      snapshotDescription: "",
      selectedNav: '',
      filteredNavs: []
    };

    this.getEntities();
  }

  getEntities() {
    axiosClient.get("/entities").then((res) => {
      this.setState({ entities: res.data });
      // if(res.data.length>1){
      //   this.setState({ showEntityDialog: true });
      // } else{
      this.setState({ currentEntity: res.data[0].subGroupDescription });
      // }
      if (res.data.length == 1) {
        this.setState({ showEntityButton: false })
      }
    });
  }

  onTopbarItemClick(event, item) {
    if (this.props.onTopbarItemClick) {
      this.props.onTopbarItemClick({
        originalEvent: event,
        item: item,
      });
    }
  }
  handleEntityChange(e) {

    axiosClient.put("/entity/" + e.id + "/"+e.subGroupId).then(() => {
      this.setState({
        currentEntity: e.subGroupDescription,
        showEntityDialog: false,
        // redirect:true
      });
      let location = ("#/");
      const win = window.open(location, "_self");
      win.focus();
      window.location.reload();
    });
  }

  snapshot() {
    axiosClient.get("/snapshot/snapshots").then((res) => {
      this.setState({ snapshotsResponse: res.data });
      this.setState({ showSnapshotDialog: true });
    });
  }

  submitSnapshot() {
    axiosClient.put("/snapshot/snapshot", { description: this.state.snapshotDescription })
      .then((res) => {
        // close.
        this.setState({ showSnapshotDialog: false });
        setTimeout(() => {
          window.location = "#/jobs/all";
        }, 3000);
      });
  }

  deleteBodyTemplate(rowData) {
    return <React.Fragment>
      <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-mr-2" onClick={() => {
        axiosClient.delete("/snapshot/snapshot/" + rowData.id)
          .then((res) => {
            this.setState({ snapshotsResponse: { snapshots: res.data } });
          });
      }} />
    </React.Fragment>;
  }

  restoreBodyTemplate(rowData) {
    return <React.Fragment>
      <Button icon="pi pi-play" className="p-button-rounded p-button-success p-mr-2" onClick={() => {
        axiosClient.put("/snapshot/restore/" + rowData.id)
          .then((res) => {
            this.setState({ showSnapshotDialog: false });
            setTimeout(() => {
              window.location = "#/jobs/all";
            }, 3000);
          });
      }} />
    </React.Fragment>;
  }

  searchNavs(e) {
    const q = e.query;
    const p = localStorage.getItem('permissions').split(',');
    let x = smartNavigation
      .filter(s => {
        let tokensA = s.name.toLowerCase().split(" ");
        let tokensB = q.toLowerCase().split(" ");
        var setB = new Set(tokensB);
        let intersect = [...new Set(tokensA)].filter(x => setB.has(x));
        let a = s.name.toLowerCase().includes(q.toLowerCase());
        let b = p.filter(value => s.permission === undefined || s.permission.includes(value)).length > 0;
        return (intersect.length > 0 || a) && b;
      }).map(s => {
        return { label: s.name, value: s.path, category: s.category }
      });
    this.setState({ filteredNavs: x });
  }

  itemTemplate(data) {
    return <>
      <b>Category: {data.category}</b>
      <hr />
      <span>{data.label}</span>
    </>
  }

  render() {
    let snapshotForm = <h3 style={{ color: "red" }}>Your Snapshot Quota has exceeded. Please delete one or more Snapshots.</h3>
    if (!this.state.snapshotsResponse.quotaReached) {
      snapshotForm = <div className="p-grid p-fluid">
        <div className="p-col-8 p-md-8">
          <InputText placeholder="Snapshot Description" value={this.state.snapshotDescription} onChange={e => this.setState({ snapshotDescription: e.target.value })} />
        </div>
        <div className="p-col-4 p-md-4">
          <Button iconPos="left" icon="pi pi-save" label="Take Snapshot" className="p-button-success" onClick={this.submitSnapshot} />
        </div>
      </div>;
    }

    return (
      <div className="topbar clearfix" >
        <div className="topbar-left">
          <img
            alt="Logo"
            src="assets/layout/images/l.png"
            className="topbar-logo"
          />
        </div>


        <div className="topbar-right">
          <button
            className="p-link"
            id="menu-button"
            onClick={this.props.onMenuButtonClick}
            aria-label="Toggle menu"
          >
            <i className="fa fa-angle-left"></i>
          </button>
          <div style={{ position: 'absolute', right: 'max(350px, 40%)' }}>
            <span className="p-input-icon-left">
              <AutoComplete
                size={60}
                aria-label="Smart navigation search"
                placeholder="Smart Navigation - Type anything eg: TDS"
                value={this.state.selectedNav}
                suggestions={this.state.filteredNavs}
                completeMethod={this.searchNavs}
                field="label"
                itemTemplate={this.itemTemplate}
                onChange={(e) => {
                  this.setState({ selectedNav: e.value });
                  if (e.value.value !== undefined) {
                    window.location = e.value.value;
                    this.setState({ selectedNav: '' });
                  }
                }} />
            </span>
          </div>
          <div style={{ position: 'absolute', right: '350px' }}>
            <a style={{ color: "#fff" }} target='_blank' rel="noopener noreferrer" href="https://www.taxreco.com/"><div>Made with <span style={{ color: "#e25555" }}>&#9829;</span> by TaxReco Team</div></a>
          </div>
          <div style={{ float: 'right', width: 'fit-content' }}>
            <Button iconPos="left"
              icon="pi pi-bell"
              aria-label="View all jobs"
              tooltip={"Jobs"} tooltipOptions={{ position: 'bottom' }}
              className="p-button-success" onClick={e => {
                window.location = "#/jobs/all";
              }} />
          </div>
          <div style={{ float: 'right', width: 'fit-content' }}>
            <Button iconPos="left"
              aria-label="Manage snapshots"
              tooltip={"Snapshots"} tooltipOptions={{ position: 'bottom' }}
              icon="pi pi-save" className="p-button-danger" onClick={this.snapshot} />
          </div>
          <div style={{ marginRight: "10px", float: 'right', width: 'fit-content' }}>
            <Dropdown
              value={this.state.currentEntity}
              filter
              filterBy="subGroupDescription"
              options={this.state.entities}
              optionLabel="subGroupDescription"
              placeholder={this.state.currentEntity}
              style={{ float: "right" }}
              onChange={(e) => this.handleEntityChange(e.value)}
            ></Dropdown>
          </div>
          <Dialog header="Snapshot" visible={this.state.showSnapshotDialog} modal={true} style={{ width: '70vw', height: '70vw' }} onHide={() => this.setState({ showSnapshotDialog: false })}>
            <div className="card card-w-title">
              <h1>Take a data snapshot</h1>
              {snapshotForm}
              <br /><br />
              <hr /><br />
              <Toolbar>
                <div className="p-toolbar-group-right">
                  <Button icon="pi pi-refresh" className="p-button-rounded p-button-info p-mr-2" onClick={this.snapshot} alt={'Refresh results'} />
                </div>
              </Toolbar>
              <DataTable header={"Your existing data snapshots"} value={this.state.snapshotsResponse.snapshots}>
                <Column style={{ textAlign: 'right' }} field="description" header={"Description"} />
                <Column style={{ textAlign: 'right' }} field="userId" header={"User ID"} />
                <Column style={{ textAlign: 'right' }} field="dateTimeString" header={"Date Time"} />
                <Column style={{ textAlign: 'right' }} body={this.deleteBodyTemplate} header="Delete" />
                <Column style={{ textAlign: 'right' }} body={this.restoreBodyTemplate} header="Restore" />
              </DataTable>
            </div>
          </Dialog>;
        </div>
      </div>
    );
  }
}